import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myLibraryTeachModal from 'redux/selectors/my_library/my_library_teach_modal'

import TeachLessonModal from 'views/my_library/modals/teach_lesson/teach_lesson'

const TeachLessonModalContainer = props => {
	const launchLiveLesson = () => {
		props.actions.launchLiveLesson(props.entity.data.presentation_uid)
	}

	const launchLiveLessonWithZoom = () => {
		props.actions.launchLiveLesson(props.entity.data.presentation_uid, true)
	}

	const launchFrontOfTheClassroom = () => {
		props.actions.launchFrontOfTheClassroom(props.entity.data.presentation_uid)
	}

	const launchHomework = () => {
		props.actions.launchNewHomework(props.entity.data.presentation_uid)
	}

	const handleLiveActiveCodesSelected = () => {
		props.actions.liveActiveCodesSelected(
			props.entity.data.presentation_uid,
			props.hasMultipleLiveSessionPins,
			false
		)
	}

	const handleLiveWithZoomActiveCodesSelected = () => {
		props.actions.liveActiveCodesSelected(
			props.entity.data.presentation_uid,
			props.hasMultipleLiveSessionPins,
			true
		)
	}

	const handleHomeworkActiveCodesSelected = () => {
		// TODO: change this to get the codes with the complete data when showing the links and use
		// that directly instead of using the launch homework
		props.actions.launchHomework(props.entity.data.presentation_uid)
	}

	return (
		<TeachLessonModal
			onCloseSelected={props.actions.handleModalClosed}
			onSettingsSelected={props.actions.settingsSelected}
			canLaunchFrontOfTheClassroom={props.entity.canLaunchFrontOfTheClassroom}
			canLaunchSession={props.entity.canLaunchSession}
			canLaunchSessionWithZoom={props.entity.canLaunchSessionWithZoom}
			canLaunchHomework={props.entity.canLaunchHomework}
			launchFrontOfTheClassroom={launchFrontOfTheClassroom}
			launchLiveLesson={launchLiveLesson}
			launchHomework={launchHomework}
			launchLiveLessonWithZoom={launchLiveLessonWithZoom}
			hasActiveLiveCodes={props.hasActiveLiveCodes}
			hasActiveHomeworkCodes={props.hasActiveHomeworkCodes}
			onLiveActiveCodesSelected={handleLiveActiveCodesSelected}
			onLiveWithZoomActiveCodesSelected={handleLiveWithZoomActiveCodesSelected}
			onHomeworkActiveCodesSelected={handleHomeworkActiveCodesSelected}
		/>
	)
}

function mapStateToProps(state) {
	return myLibraryTeachModal(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		handleModalClosed: myLibraryActions.teachLessonModalCloseSelected,
		settingsSelected: myLibraryActions.lessonSettingsSelected,
		launchFrontOfTheClassroom: myLibraryActions.launchFrontOfTheClassroom,
		launchLiveLesson: myLibraryActions.launchNewSession,
		launchNewHomework: myLibraryActions.launchNewHomework,
		liveActiveCodesSelected: myLibraryActions.liveActiveCodesSelected,
		launchHomework: myLibraryActions.launchHomework,
	}, dispatch)
}

TeachLessonModalContainer.propTypes = {
	actions: PropTypes.shape({
		handleModalClosed: PropTypes.func.isRequired,
		settingsSelected: PropTypes.func.isRequired,
		launchFrontOfTheClassroom: PropTypes.func,
		launchLiveLesson: PropTypes.func,
		launchNewHomework: PropTypes.func,
		liveActiveCodesSelected: PropTypes.func,
		launchHomework: PropTypes.func,
	}),
	entity: PropTypes.shape({
		canLaunchFrontOfTheClassroom: PropTypes.bool,
		canLaunchSession: PropTypes.bool,
		canLaunchSessionWithZoom: PropTypes.bool,
		canLaunchHomework: PropTypes.bool,
		data: PropTypes.shape({
			presentation_uid: PropTypes.string,
		}),
	}).isRequired,
	hasActiveLiveCodes: PropTypes.bool,
	hasActiveHomeworkCodes: PropTypes.bool,
	hasMultipleLiveSessionPins: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(TeachLessonModalContainer)

export {
	TeachLessonModalContainer,
}
